const styles = (theme) => ({
  barraFiltros: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    "@media (max-width:1349px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  botaoFiltros: {
    whiteSpace: "nowrap",
    height: 40,
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
  // Mesmo botão de atualizar do dashboard (3.0-dashboard), girando ao carregar.
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    lineHeight: 1,
    minWidth: "unset",
    width: "40px",
    height: "40px",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .rotating": { animation: "spin 1s linear infinite" },
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "100%": { transform: "rotate(-360deg)" },
    },
  },
  chipMeusTickets: {
    height: 40,
    borderRadius: "20px",
    px: 0.5,
  },
  chipsAtivos: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 0.75,
    mb: 1,
  },
  paperPanel: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    pt: 2,
  },
  loadingLinearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  titlePanel: {
    fontSize: "16px",
    fontWeight: 600,
    px: 2,
  },
  headerTickets: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "stretch", md: "center" },
    justifyContent: "space-between",
    gap: 1,
    px: 2,
    mt: -1,
  },
  tabs: {
    minHeight: 40,
    "& .MuiTab-root": {
      minHeight: 40,
      textTransform: "none",
      fontWeight: 600,
    },
  },
  busca: {
    width: "100%",
    maxWidth: 500,
    flexGrow: 1,
  },
  // Altura fixa (não cresce com o número de linhas; a tabela rola): a
  // paginação fica sempre no fim do Paper, com qualquer quantidade de tickets.
  boxDatagrid: {
    height: 620,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
  },
  // Linhas de 52px (o datagridComponent força 28px com !important) para as
  // células de duas linhas.
  datagrid: {
    flex: 1,
    minHeight: 0,
    height: "auto",
    // O datagridComponent declara "& .MuiDataGrid-cell" duas vezes e a 2ª
    // apaga o alinhamento da 1ª: todo conteúdo centralizado na vertical.
    "& .MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
    },
    "& .MuiDataGrid-row": {
      minHeight: "52px !important",
      maxHeight: "52px !important",
      cursor: "pointer",
    },
  },
  cellStack: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minWidth: 0,
    lineHeight: 1.3,
  },
  linkCliente: {
    fontWeight: 600,
    color: "text.primary",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },
  etapa: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0,
  },
  etapaDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
    bgcolor: "text.disabled",
  },
  protocolo: {
    fontSize: "0.82rem",
    whiteSpace: "nowrap",
  },
  // Selo do ERP compacto, para caber como 2ª linha da célula de 52px.
  seloErp: {
    height: 18,
    minWidth: 0,
    fontSize: "0.62rem",
    alignSelf: "flex-start",
    mt: 0.25,
    "& .MuiChip-label": { px: 0.75 },
  },
  botaoVerTicket: {
    whiteSpace: "nowrap",
    textTransform: "none",
  },
  avatarGroup: {
    justifyContent: "flex-end",
    "& .MuiAvatar-root": {
      width: 28,
      height: 28,
      fontSize: 12,
    },
  },
  // Ao lado da tabela (xxl), os dois painéis dividem a altura dela; abaixo
  // (telas menores), lado a lado com altura fixa.
  boxPaineis: {
    display: "flex",
    flexDirection: { xs: "column", md: "row", xxl: "column" },
    gap: 1,
    // xxl: preenche a célula do Grid (8px = spacing) sem ditar a altura dela;
    // quem define a altura da linha é a tabela.
    position: { xxl: "absolute" },
    top: { xxl: 8 },
    left: { xxl: 8 },
    right: { xxl: 0 },
    bottom: { xxl: 0 },
    width: { xs: "100%", xxl: "auto" },
  },
  paperRanking: {
    flex: { xxl: 1 },
    minHeight: 0,
  },
  boxRanking: {
    height: { xs: 235, xxl: "auto" },
    flex: { xxl: 1 },
    minHeight: 0,
    overflowY: "auto",
    py: 0.5,
  },
  rankingItem: {
    px: 2,
    py: 0.75,
  },
  rankingLabel: {
    display: "flex",
    justifyContent: "space-between",
    gap: 1,
    mb: 0.5,
  },
  rankingBar: {
    height: 6,
    borderRadius: 5,
  },
  mobileCardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 1,
  },
  mobileCard: {
    borderRadius: 3,
    p: 1.5,
    cursor: "pointer",
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 1,
    mb: 1,
  },
  mobileDescription: {
    mt: 0.5,
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
  },
  mobileCardFooter: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 1,
  },
  drawer: {
    width: { xs: "100vw", sm: 400 },
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 1,
    "& p": { px: 1 },
  },
  drawerBody: {
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: 2,
  },
  drawerFooter: {
    display: "flex",
    justifyContent: "space-between",
    p: 2,
  },
});

export default styles;
